export enum CourseraPlusOnlyS12nIds {
  // google-ai-for-healthcare-professionals
  GOOGLE_AI_FOR_HEALTHCARE_PROFESSIONALS = 'kvZ2uih5Re21scT8zjdCIQ',
  // google-ai (temporary stand-in while google-ai-for-healthcare-professionals is still in draft)
  GOOGLE_AI = 'child~AFxXmO-8QSOxiGqOTtllvw',
}

export const COURSERA_PLUS_ONLY_S12N_QUERY_PARAM = 'courseraPlusOnlyS12n';

const COURSERA_PLUS_ONLY_S12N_IDS: ReadonlyArray<string> = Object.values(CourseraPlusOnlyS12nIds);

// Temporary opt-in so the live `google-ai` s12n is unaffected until launch.
const hasCourseraPlusOnlyS12nQueryParam = (): boolean => {
  if (typeof window === 'undefined') {
    return false;
  }

  // Disabled: uncomment this return and remove `return false` below to resume C+ only enrollment.
  // return new URLSearchParams(window.location.search).get(COURSERA_PLUS_ONLY_S12N_QUERY_PARAM) === 'true';
  return false;
};

// C+ only s12ns must not offer direct s12n subscriptions (free trial or paid).
export const isCourseraPlusOnlyS12n = (s12nId?: string | null): boolean => {
  if (!s12nId || !hasCourseraPlusOnlyS12nQueryParam()) {
    return false;
  }

  return COURSERA_PLUS_ONLY_S12N_IDS.includes(s12nId);
};
